import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { RefreshLoginFailure, RefreshLoginRequest, RefreshLoginSuccess } from './actions';
import { RefreshLoginParams, RefreshLoginService } from './service';
import { UpdateTkJwt } from '@store/flow-data/general';

@Injectable()
export class RefreshLoginEffects {
  private readonly actions$ = inject(Actions);
  private readonly refreshLoginService = inject(RefreshLoginService);

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RefreshLoginRequest),
      switchMap(({ parameters }: { parameters?: RefreshLoginParams }) =>
        this.refreshLoginService.refreshLogin(parameters).pipe(
          switchMap(data => [UpdateTkJwt({ data: data.token }), RefreshLoginSuccess({ data })]),
          catchError(error => of(RefreshLoginFailure({ error })))
        )
      )
    )
  );

}
